module.exports = __webpack_public_path__ + "video/2500-3_YR_2022_Vishing.a5b8b969.vtt";